import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  Autocomplete,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Delete } from "@material-ui/icons";
import { getTaxCard, vendorTaxDetail } from "../../actions";
import "./style.css";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});

function TaxTable_Short({
  formState,
  setFormState,
  tempSetFormState,
  invoicePayload,
  disabled,
}) {
  const tableData = {
    taxId: 0,
    invoice_Id: 0,
    taxType: "",
    taxCode: "",
    amount: formState.invoice_Amount,
    comments: "",
    created_By: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    taxCardId: 0,
  };
  const classes = useStyles();

  const [taxTableDropdownData, setTaxTableDropdownData] = useState({
    categories: [],
    purchaseType: [],
    supplierJurisdiction: [],
    supplierType: [],
    status: [],
    fillingStatus: [],
    goodsNature: [],
    taxType: [],
    taxCode: [],
  });

  const [taxCardLoading, setTaxCardLoading] = useState(false);
  const [taxCardData, setTaxCardData] = useState(false);

  const addInput = () => {
    setFormState((formState) => ({
      ...formState,
      invoice_TaxDetails: [...formState.invoice_TaxDetails, tableData],
    }));
  };

  const deleteInput = (index) => {
    const filteredData = formState?.invoice_TaxDetails?.filter(
      (x, i) => i !== index
    );

    setFormState((formState) => ({
      ...formState,
      invoice_TaxDetails: filteredData,
    }));
  };

  const changeHandler = (e, index) => {
    const { name, value } = e.target;
    let tempArray = formState.invoice_TaxDetails;
    tempArray[index] = {
      ...formState.invoice_TaxDetails[index],
      [name]: value,
    };

    setFormState((formState) => ({
      ...formState,
      invoice_TaxDetails: tempArray,
    }));
  };

  // useEffect(() => {
  //   // getTaxCard(setTaxTableDropdownData, setTaxCardLoading, setTaxCardData);
  //   // vendorTaxDetail(
  //   //   setTaxTableDropdownData,
  //   //   tempSetFormState,
  //   //   formState,
  //   //   invoicePayload?.Vendor_Code,
  //   //   invoicePayload?.Invoice_id,
  //   //   setTaxCardLoading
  //   // );
  // }, []);

  // FOR RE-USE the action(vendorTaxDetail) WE DO THIS
  // this is only used when invoice is created by import user.

  const autoCompleteChangeHandler = (name, newValue, index) => {
    let tempArray = formState.invoice_TaxDetails;
    tempArray[index] = {
      ...formState.invoice_TaxDetails[index],
      [name]: newValue,
    };

    setFormState((formState) => ({
      ...formState,
      invoice_TaxDetails: tempArray,
    }));

    // setTaxTableDropdownSelected((taxTableDropdownSelected) => ({
    //   ...taxTableDropdownSelected,
    //   [name]: newValue,
    // }));

    if (name === "category") {
      const finded = taxCardData.find((x) => x.category === newValue?.[name]);
      tempArray[index] = {
        ...formState.invoice_TaxDetails[index],
        category: finded.category,
        purchaseType: finded.purchaseType,
        supplierJurisdiction: finded.supplierJurisdiction,
        supplierType: finded.supplierType,
        status: finded.status,
        fillingStatus: finded.fillingStatus,
        goodsNature: finded.goodsNature,
      };
      setFormState((formState) => ({
        ...formState,
        invoice_TaxDetails: tempArray,
      }));
      // // setTaxTableDropdownSelected((taxTableDropdownSelected) => ({
      // //   ...taxTableDropdownSelected,
      // // }));
      // setFormState((formState) => ({
      //   ...formState,
      // }));
    }
  };
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0px" }}>
          <TableContainer className="scrollable">
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4", fontSize: "11" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Tax Type
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    WHT Code
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Base Amount
                  </TableCell>
                  {!disabled && (
                    <TableCell
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "#031c30",
                      }}
                    >
                      Action
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {formState?.invoice_TaxDetails.length > 0 &&
                  formState?.invoice_TaxDetails?.map((item, index) => {
                    return (
                      <TableRow
                        key={index}
                        // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      >
                        <TableCell sx={{ padding: "10px" }}>
                          <Autocomplete
                            id="selectedTaxCode"
                            options={taxTableDropdownData?.taxType}
                            size="small"
                            disabled={disabled}
                            value={{
                              taxType: item?.taxType || "",
                            }}
                            getOptionLabel={(option) =>
                              (option !== "" &&
                                `${option?.TaxType || option?.taxType}`) ||
                              ""
                            }
                            // key={(option) => option?.taxType}
                            loading={taxCardLoading}
                            variant="standard"
                            onChange={(event, newValue) => {
                              autoCompleteChangeHandler(
                                "taxType",
                                newValue?.taxType,
                                index
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                type="text"
                                name=""
                                variant="standard"
                                required
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell sx={{ padding: "10px" }}>
                          <Autocomplete
                            id=""
                            options={taxTableDropdownData?.taxCode}
                            size="small"
                            disabled={disabled}
                            value={{
                              taxCode: item?.taxCode || "",
                            }}
                            getOptionLabel={(option) =>
                              (option !== "" && `${option?.taxCode}`) || ""
                            }
                            // key={(option) => option?.TaxCode}
                            loading={taxCardLoading}
                            variant="standard"
                            onChange={(event, newValue) => {
                              autoCompleteChangeHandler(
                                "taxCode",
                                newValue?.taxCode,
                                index
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                type="text"
                                name=""
                                variant="standard"
                                required
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell sx={{ padding: "10px" }}>
                          <TextField
                            type="number"
                            size="small"
                            fullWidth
                            variant="standard"
                            disabled={disabled}
                            name="amount"
                            value={item?.amount || item?.Amount || ""}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        {!disabled && (
                          <TableCell align="center">
                            <Delete
                              color="error"
                              onClick={() => {
                                deleteInput(index);
                              }}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            {formState?.invoice_TaxDetails.length === 0 && <EmptyData />}
          </TableContainer>
          {!disabled && (
            <Box display="flex" justifyContent={"flex-end"} mt={2}>
              <Button color="secondary" variant="contained" onClick={addInput}>
                Add New Row
              </Button>
            </Box>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default TaxTable_Short;
